import { Breakpoints } from '@angular/cdk/layout';

export const environment = {
  production: true,
  enablePwaMode: false,
  enableNgxsDevMode: false,
  title: 'Amco Tour Tracking - QA',
  mobileTitle: 'Amco Tour Tracking',
  inMemory: false,
  inMemoryDelay: 2000,
  mobileModeBreakpoint: [
    Breakpoints.Handset,
    Breakpoints.HandsetLandscape,
    Breakpoints.HandsetPortrait,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Tablet,
    Breakpoints.TabletLandscape,
    Breakpoints.TabletPortrait
  ],
  inferiorBrowsers: ['ie', 'edge', 'safari'],
  routeOnLogout: {
    enabled: true,
    url: ['/auth/login']
  },
  allowLoginDialog: false,
  defaultToAdUser: true,
  globalHttpActivitySpinner: true,
  globalHttpErrorSnackbar: true,
  globalHttpErrorSnackbarDuration: 5000,
  blockUiOnSignalrDisconnect: false,
  googleApiKey: 'AIzaSyAcWlJ8wHmO1L4p9Ap3Vq_bm7uTeazyX4E',
  webApiBaseAddress: 'https://amcotourtrackingqa.supergrp.net/WebApi',
  signalRBaseAddress: 'https://amcotourtrackingqa.supergrp.net/WebApi/Hub',
  reportConfig: {
    reportApiBaseAddress: 'https://www.sg-api.co.za/SSRSApi/api/',
    clientId: '0a43a802-abd8-4e90-9087-c63c3ab3563d',
    userReference: 'sub'
  }
};
